/**
 * Base entity class that all entities should extend
 * Provides common functionality for entity management
 */
export abstract class BaseEntity {
  protected _isDirty: boolean = false;
  protected _originalData: any = {};

  /**
   * Mark the entity as modified
   */
  protected markAsDirty(): void {
    this._isDirty = true;
  }

  /**
   * Check if the entity has been modified
   */
  isDirty(): boolean {
    return this._isDirty;
  }

  /**
   * Reset dirty state after saving
   */
  markAsClean(): void {
    this._isDirty = false;
    this._originalData = this.toData();
  }

  /**
   * Set original data when loading from database
   */
  setOriginalData(data: any): void {
    this._originalData = { ...data };
    this._isDirty = false;
  }

  /**
   * Get changes made to the entity
   */
  getChanges(): Partial<any> {
    if (!this._isDirty) return {};
    
    const currentData = this.toData();
    const changes: any = {};
    
    Object.keys(currentData).forEach(key => {
      if (currentData[key] !== this._originalData[key]) {
        changes[key] = currentData[key];
      }
    });
    
    return changes;
  }

  /**
   * Convert entity to plain data object
   * Must be implemented by child classes
   */
  abstract toData(): any;
}